import React from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const ErrorMessage = ({ 
  error, 
  onRetry = null, 
  className = '',
  title = 'Something went wrong',
  showDetails = true 
}) => {
  const errorMessage = error?.message || error || 'An unexpected error occurred. Please try again.';

  const copyErrorToClipboard = () => {
    const errorText = `Error: ${errorMessage}\nTimestamp: ${new Date()?.toISOString()}`;
    navigator.clipboard?.writeText(errorText);
  };

  return (
    <div className={`bg-destructive/10 border border-destructive/20 rounded-organic p-4 ${className}`}>
      <div className="flex items-start space-x-3">
        <Icon name="AlertCircle" size={20} className="text-destructive mt-0.5 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <h3 className="font-heading font-heading-bold text-sm text-destructive mb-1">
            {title}
          </h3>
          {showDetails && (
            <p className="font-body text-sm text-destructive/80 mb-3">
              {errorMessage}
            </p>
          )}
          <div className="flex flex-wrap gap-2">
            {onRetry && (
              <Button
                onClick={onRetry}
                variant="outline"
                size="sm"
                iconName="RefreshCw"
                iconPosition="left"
                className="text-destructive border-destructive/30 hover:bg-destructive/10"
              >
                Try Again
              </Button>
            )}
            <Button
              onClick={copyErrorToClipboard}
              variant="ghost"
              size="sm"
              iconName="Copy"
              iconPosition="left"
              className="text-destructive/70 hover:text-destructive hover:bg-destructive/10"
            >
              Copy Error
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;